import Vue from 'vue'
import Router from 'vue-router'
import Layout from '@/views/index'

Vue.use(Router)

// 公共路由
export const constantRoutes = [
  {
    path: '/',
    component: Layout,
    redirect: '/index',
    children: [
      {
        path: 'index',
        component: (resolve) => require(['@/views/home/index'], resolve),
        name: 'HomeIndex',
        meta: { title: '首页' }
      },
      {
        path: 'software',
        component: (resolve) => require(['@/views/software/index'], resolve),
        name: 'Software',
        meta: { title: '软件产品' }
      },
      {
        path: 'cooperation',
        component: (resolve) => require(['@/views/cooperation/index'], resolve),
        name: 'Cooperation',
        meta: { title: '学校合作' }
      },
      {
        path: 'hardware',
        component: (resolve) => require(['@/views/hardware/index'], resolve),
        name: 'Hardware',
        meta: { title: '硬件设备' }
      }
    ]
  }
]

export default new Router({
  mode: 'history', // 去掉url中的#
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRoutes
})
